import { trakrefFontFamily } from "../../utils";

export const complianceCheckupfilterOptions = [
    { type: "dropdown", name: "Year", property: "assetType" },
    { type: "dropdown", name: "Region Division", property: "instanceAssociationId" },
];

export const columns = [
    { id: 'Location', title: "LOCATION", property: "locationName", key: "locationName", linkPath: "/Location", linkId: "locationID", contsructLink: true },
    { id: 'ValidationMessage', title: "VALIDATION MESSAGE", property: "message", key: "message" },
    { id: 'ValidationLink', title: "VALIDATION LINK", property: "referenceUrlName", key: "referenceUrlName", linkId: "referenceUrl" },
];

export const assetTypeOptions = [
    { id: 22, label: 'Refrigeration' },
    { id: 31, label: 'Comfort Cooling' },
    { id: 63, label: 'Process Cooling' },
];

export const assetStatusOptions = [
    { id: 1, label: 'Active' },
    { id: 2, label: 'Inactive' },
];

export const contactEpafilterOptionColumns = [
    { type: "dropdown", name: "Asset Type", property: "assetType", translateId: "serviceEventView.assetDetailInfo.asset-type" },
    { type: "dropdown", name: "Material Type", property: "materialType", translateId: "serviceEventView.assetDetailInfo.material-type" },
    { type: "text", name: "Gas Capacity", property: "maxGasCapacityLbs", translateId: "rapidCylinderEntry.cylinderInputForm.gas-capacity" },
    { type: "text", name: "Current Gas Weight", property: "currentGasWeightLbs", translateId: "rapidCylinderEntry.current-Gas-Weight" },
    { type: "text", name: "Tag Number", property: "tagNumber", translateId: "rapidCylinderEntry.cylinderInputForm.tag-number" },
    { type: "date", name: "Acquisition Date", property: "acquisitionDate", translateId: "assetDetailsMainTab.acquisition-date" },
];

export const locationLabelStyle = {
    width: '33%',
    flexShrink: 0,
    color: "#00859B",
    fontSize: '13px',
    fontWeight: 600,
    fontFamily: trakrefFontFamily
};

export const assetLabelStyle = {
    color: '#000000',
    fontFamily: trakrefFontFamily,
    fontSize: '18px'
};

export const searchBarStyle = {
    '& .MuiInputBase-input': { padding: '6.5px 14px' }
};

export const handleMultiSelectChange = (setter) => (e) => {
    const newValue = e.target.value;
    const wasAllSelected = newValue.length > 1 && newValue[0] === "-1";
    const isAllNowSelected = newValue.includes("-1") && newValue[newValue.length - 1] === "-1";

    if (isAllNowSelected) {
        setter(["-1"]);
    } else if (wasAllSelected) {
        setter(newValue.filter(v => v !== "-1"));
    } else if (newValue.length === 0) {
        setter(["-1"]);
    } else {
        setter(newValue);
    }
};

export const getReasonsForLetters = (letterType) => {
    const reasonsForLetters = {
        1: [
            { id: 1, label: "Awaiting Parts" },
            { id: 2, label: "Radiological Contamination" },
            { id: 3, label: "Additional Time Needed" },
            { id: 4, label: "Other applicable regulation make retrofit or retirement within 1 one year impossible" },
        ],
        2: [
            { id: 1, label: "Awaiting Parts" },
            { id: 2, label: "Radiological Contamination" },
            { id: 4, label: "Other applicable regulation make retrofit or retirement within 1 one year impossible" },
        ],
        4: [
            { id: 1, label: "Substitute Refrigerant" },
            { id: 2, label: "Awaiting Parts" },
            { id: 3, label: "Radiological Contamination" },
            { id: 4, label: "Additional Time Needed" },
            { id: 5, label: "Other applicable regulation make retrofit or retirement within 1 one year impossible" },
        ]
    };
    return reasonsForLetters[letterType] || [];
};